import React from 'react';
import {useTable} from "react-table";
import {useLocation, useNavigate} from "react-router-dom";
import "./AccountTableStyle.css";

const AccountTable = ({ columns, data, baseUrl }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <table {...getTableProps()}>
            <thead>
            {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                    ))}
                </tr>
            ))}
            </thead>
            <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
                prepareRow(row);
                return (
                    <tr {...row.getRowProps()}
                        onClick={() => {
                            if (row.original.id !== null) {
                                navigate(`${baseUrl}/${row.original.id}`);
                            }
                        }}
                        className={
                            location.pathname.split('/')[location.pathname.split('/').length - 1] === row.original.id ?
                                "row-selected"
                                :
                                ""
                        }
                    >
                        {row.cells.map((cell, index) => (
                            <td className='tdComponent' key={index} {...cell.getCellProps()}>
                                <span>{cell.render("Cell")}</span>
                            </td>
                        ))}
                    </tr>

                );
            })}
            </tbody>
        </table>
    );
};

export default AccountTable;